export default __webpack_public_path__ + "static/media/uk.202f027d.svg";